'use strict';

module Patersons {
    export class WatchlistItem {
        id: number;         
        watchlistId: number;       
        isin: string;        

        constructor(watchlistId: number, isin: string) {                        
            this.isin = isin;       
            this.watchlistId = watchlistId;     
        }
    } 
    export class Watchlist {
        name: string;
        description: string;
        id: number;
        relatedInvestorId: number;
        watchlistItems: Array<string>;
        
        constructor(watchlistId?: number, name?: string, description?: string) {
            this.id = watchlistId;
            this.name = name;
            this.description = description;
            this.watchlistItems = new Array<string>();
        }
    } 
    export class Security {
        securityCode: string;
        isin: string;
        securityDescription: string;
        exchange: string;
        securityType: number;
    }
    export enum SelectListType {
        portfolio = 1,
        model = 2,
        watchlist = 3
    }
    export class WatchlistSelectListDescriptor {
        itemType: SelectListType;
        id: string;
        label: string;
    }
}